import { TFunction } from 'react-i18next';
import React from 'react';
import { PasswordResetForm } from 'modules/profilePage/components/passwordResetForm';
import { ViewProfileForm } from './viewProfileForm';
import { ProfilePageKeys } from './helper';
import { EditProfileForm } from './editProfileForm';
import { EditContactPersonForm } from './editContactPersonForm';

export interface ProfilePageTabItem {
  name: string;
  key: string;
  component: React.ReactNode;
}

export const getProfilePageTabs = (t: TFunction): ProfilePageTabItem[] => [
  {
    name: t('profilePage.navigation.dataOverview'),
    key: ProfilePageKeys.Information,
    component: <ViewProfileForm />,
  },
  {
    name: t('profilePage.navigation.dataModification'),
    key: ProfilePageKeys.DataModification,
    component: <EditProfileForm />,
  },
  {
    name: t('profilePage.navigation.passwordReset'),
    key: ProfilePageKeys.PasswordReset,
    component: <PasswordResetForm />,
  },
  {
    name: t('profilePage.navigation.contactPerson'),
    key: ProfilePageKeys.ContactPerson,
    component: <EditContactPersonForm />,
  },
];
